export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"tokenStorage": "localStorage", "httpEndpoint": "http://core-apollo:3020/graphql", "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "defaultOptions": undefined, "browserHttpEndpoint": "/graphql"}}
}